import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tooltip@3.7.2@rc-tooltip/es/index.js
// module id = 1371
// module chunks = 0 1